module.exports = __webpack_public_path__ + "static/img/2.854d699.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/test/2.jpg
// module id = BGvU
// module chunks = 1